import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [favorites, setFavorites] = useState([]);

  const loadFavorites = useCallback(async () => {
    try {
      const res = await api.get("/favorites/ids");
      setFavorites(res.data);
    } catch (e) {
      setFavorites([]);
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
      loadFavorites();
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, [loadFavorites]);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(null);
    setFavorites([]);
  };

  const toggleFavorite = async (propertyId) => {
    const res = await api.post(`/favorites/${propertyId}`);
    setFavorites((prev) =>
      res.data.favorited ? [...prev, propertyId] : prev.filter((id) => id !== propertyId)
    );
    return res.data.favorited;
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser, loading, login, logout, favorites, toggleFavorite, loadFavorites }}
    >
      {children}
    </AuthContext.Provider>
  );
};
